/**
 * Shared HITL 3.0 font size, defined once so it can be tuned in a single place
 * and reused across the hitl_3_0 UI — intent buttons, live-transcript messages,
 * Customer Pulse, modifier choices and the shortcuts popover.
 *
 * IMPORTANT: apply this ONLY behind the hitl_3_0 flag / inside hitl3-only
 * components. The legacy layout keeps its own sizes and must not reference this,
 * so bumping the value here never affects the old UI.
 */
export const HITL3_FONT_SIZE = '0.875rem'; // 14px at the 16px root
